import { CSSProperties, ReactElement, useLayoutEffect, useRef } from "react";
import { RowComponentProps } from "react-window";

import { LISTBOX_PADDING } from "./list-box.constants";
import { IListBoxRowProps } from "./list-box.models";
import { measureVirtualRowHeight } from "./list-box.utils";

const getRowTopOffset = (style: CSSProperties): number => {
  const top = style.top;
  return typeof top === "number" ? top + LISTBOX_PADDING : LISTBOX_PADDING;
};

export const ListBoxVirtualizedRow = ({
  items,
  index,
  setSize,
  style,
  listLayoutSignature,
}: RowComponentProps<IListBoxRowProps>): ReactElement => {
  const rowRef = useRef<HTMLDivElement>(null);
  const rowContent = items[index];

  useLayoutEffect(() => {
    const rowElement = rowRef.current;
    if (!rowElement) {
      return undefined;
    }

    const reportHeight = (): void => {
      const measuredHeight = measureVirtualRowHeight(rowElement);
      if (measuredHeight > 0) {
        setSize(index, measuredHeight);
      }
    };

    reportHeight();

    const resizeObserver = new ResizeObserver(reportHeight);
    resizeObserver.observe(rowElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, [setSize, index, rowContent, listLayoutSignature]);

  return (
    <div
      style={{
        ...style,
        // Match MUI Virtualize demo: inset list from popper edge; itemSize stays full row height.
        top: getRowTopOffset(style),
        overflow: "visible",
      }}
    >
      <div ref={rowRef}>{rowContent}</div>
    </div>
  );
};
